<template>
  <CRow>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="primary" v-bind:header="companiesHeader" text="Companies">

        <template #footer>
          <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height:70px"
              :data-points=companiesData
              point-hover-background-color="primary"
              label="Companies"
              labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="info" v-bind:header=categoriesHeader text="Categories">
        <template #footer>
          <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height:70px"
              :data-points=categoriesData
              point-hover-background-color="info"
              :options="{ elements: { line: { tension: 0.00001 }}}"
              label="Categories"
              labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
<!--    <CCol sm="6" lg="3">-->
<!--      <CWidgetDropdown-->
<!--          color="warning"-->
<!--          header="9.823"-->
<!--          text="Members online"-->
<!--      >-->
<!--        <template #footer>-->
<!--          <CChartLineSimple-->
<!--              class="mt-3"-->
<!--              style="height:70px"-->
<!--              background-color="rgba(255,255,255,.2)"-->
<!--              :data-points="[78, 81, 80, 45, 34, 12, 40]"-->
<!--              :options="{ elements: { line: { borderWidth: 2.5 }}}"-->
<!--              point-hover-background-color="warning"-->
<!--              label="Questions"-->
<!--              labels="months"-->
<!--          />-->
<!--        </template>-->
<!--      </CWidgetDropdown>-->
<!--    </CCol>-->
<!--    <CCol sm="6" lg="3">-->
<!--      <CWidgetDropdown-->
<!--          color="danger"-->
<!--          header="9.823"-->
<!--          text="Members online"-->
<!--      >-->
<!--        <template #footer>-->
<!--          <CChartBarSimple-->
<!--              class="mt-3 mx-3"-->
<!--              style="height:70px"-->
<!--              background-color="rgb(250, 152, 152)"-->
<!--              label="Members"-->
<!--              labels="months"-->
<!--          />-->
<!--        </template>-->
<!--      </CWidgetDropdown>-->
<!--    </CCol>-->
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from '../charts/index.js'
import axios from "axios";

export default {
  name: "WidgetsDropdown",
  // components: { CChartLineSimple, CChartBarSimple },
  components: { CChartLineSimple },
  data () {
    return {
      companiesData: [],
      categoriesData:[],
      companiesHeader: '',
      categoriesHeader: ''
    }
  },
  mounted() {
    this.numberOfCompanies()
    this.numberOfCategories()
  },
  methods: {
    numberOfCompanies() {
      let self = this
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/companies/count/' + new Date().getFullYear(), {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('Widgets dropdown', response)
        self.companiesHeader = response.data.data.reduce((a, b) => a + b, 0).toString()
        self.companiesData = response.data.data
      }).catch(function (error) {
        console.log(error);
      });
    },
    numberOfCategories() {
      let self = this
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/categories/count/' + new Date().getFullYear(), {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('Widgets dropdown', response)
        self.categoriesHeader = response.data.data.reduce((a, b) => a + b, 0).toString()
        self.categoriesData = response.data.data
      }).catch(function (error) {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>

</style>
